import React, { useState } from 'react';
import { Container, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import DataProcessingAgreement from './DataProcessingAgreement';
import AssessmentMethodology from './AssessmentMethodology';
import DataSubjectRights from './DataSubjectRights';
import SecurityPolicy from './SecurityPolicy';
import Header from '../../components/auth/Header';
import Footer from '../../components/layouts/Footer';

const LegalDocumentsPage = () => {
  const [activeTab, setActiveTab] = useState('1');

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <>
      <Header />
      <Container className="py-5">
        <h1 className="mb-4">Legal Documents</h1>
        
        <Nav tabs className="mb-4">
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '1' })}
              onClick={() => toggle('1')}
              style={{ cursor: 'pointer' }}
            >
              Data Processing Agreement
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '2' })}
              onClick={() => toggle('2')}
              style={{ cursor: 'pointer' }}
            >
              Assessment Methodology
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '3' })}
              onClick={() => toggle('3')}
              style={{ cursor: 'pointer' }}
            >
              Data Subject Rights
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === '4' })}
              onClick={() => toggle('4')}
              style={{ cursor: 'pointer' }}
            >
              Security Policy
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <DataProcessingAgreement />
          </TabPane>
          <TabPane tabId="2">
            <AssessmentMethodology />
          </TabPane>
          <TabPane tabId="3">
            <DataSubjectRights />
          </TabPane>
          <TabPane tabId="4">
            <SecurityPolicy />
          </TabPane>
        </TabContent>
      </Container>
      <Footer />
    </>
  );
};

export default LegalDocumentsPage; 